import React, { useEffect, useState } from 'react';
import {
    sessionStorageClearAll,
    sessionStorageGetItem,
    sessionStorageRemoveItem,
} from '../storage/sessionStorageManager';
import { localStorageGetItem, localStorageRemoveItem } from '../storage/localStorageManager';
import { userCacheDataService } from '../../lib/api/userCacheData';
import Swal from 'sweetalert2';
import { InfoIcon, Message } from '../../lib/constants/messages';
import secureLocalStorage from 'react-secure-storage';
import { USER_DATA_CACHE_KEY, USER_DATA_IP_ADDRESS_KEY, USER_DATA_USER_AGENT_KEY } from '../../config/constants';

type Props = {
    reduxProfile: any;
    customEmail: any;
    sessionData: any;
    referralValue?: string;
    hasUnsavedChanges: boolean;
    setUseCacheData: (key: boolean) => void;
    setSessionData: (key: any) => void;
    setIso2CountryString: (key: string) => void;
};

const UnsavedChanges: React.FC<Props> = ({
    customEmail,
    reduxProfile,
    setUseCacheData,
    setSessionData,
    sessionData,
    hasUnsavedChanges,
    setIso2CountryString,
    referralValue,
}) => {
    const [ipAddress, setIpAddress] = useState('');
    const [userAgent, setUserAgent] = useState('');

    const storageData = localStorageGetItem('unclaimed', false)!;

    useEffect(() => {
        let data = sessionStorageGetItem('user-basic-details', false)!;

        if (data) {
            setSessionData({
                ...data,
                Phone: data?.OwnerPhoneNumber,
                ReferralCode: referralValue,
            });
        }

        if (storageData) {
            const { country, state } = storageData;

            if (storageData) {
                setSessionData({
                    ...data,
                    ...storageData,
                    state: state || '',
                });

                if (reduxProfile) {
                    setIso2CountryString(country === '101' ? 'IN' : '');
                }
            }
        }

        if (!storageData || !storageData?.firstName) {
            (async function () {
                try {
                    let isCacheDataPresentInLocal = secureLocalStorage.getItem(USER_DATA_CACHE_KEY) as any;

                    const { resultObject } = await userCacheDataService.getOxData(
                        reduxProfile?.email || data?.Email || customEmail
                    );

                    let cacheData = JSON.parse(resultObject?.jsonData);

                    if (cacheData && resultObject?.active && isCacheDataPresentInLocal) {
                        Swal.fire({
                            text: Message.FOUND_UNSAVED_CHANGES,
                            icon: InfoIcon,
                            showCancelButton: true,
                            confirmButtonColor: '#0096ff',
                            cancelButtonColor: '#b4acac',
                            confirmButtonText: 'Yes',
                            confirmButtonAriaLabel: 'Yes',
                            cancelButtonText: 'No',
                            cancelButtonAriaLabel: 'No',
                        }).then((result) => {
                            if (result.isConfirmed) {
                                setUseCacheData(true);
                                setSessionData({ ...sessionData, ...cacheData });
                            } else {
                                setUseCacheData(false);
                                userCacheDataService.deleteOxData(
                                    reduxProfile?.email || cacheData?.Email || cacheData?.email
                                );
                            }
                        });
                    } else {
                        setUseCacheData(false);
                    }
                } catch (err: any) {}
            })();
        }

        window.onbeforeunload = () => {
            // sessionStorageRemoveItem('candidate-basic-details');
            // sessionStorageRemoveItem('user-basic-details');
            // sessionStorageRemoveItem('candidateStep3');
            // localStorageRemoveItem('Password');
            // sessionStorageRemoveItem('userPhoneCode');
            // sessionStorageRemoveItem('companyPhoneCode');
            // sessionStorageRemoveItem('managerStep3');
            // localStorageRemoveItem('referral');
        };
    }, []);

    const confirmUnsavedChanges = (event: any) => {
        try {
            if (hasUnsavedChanges) {
                let cacheData = secureLocalStorage.getItem(USER_DATA_CACHE_KEY) as any;
                let jsonString = JSON.stringify(cacheData);

                if (cacheData?.email || cacheData?.Email || customEmail) {
                    userCacheDataService.saveOxData({
                        // id: "",
                        ipAddress: ipAddress,
                        emailId: cacheData?.email || cacheData?.Email || customEmail,
                        userAgent: userAgent,
                        jsonData: jsonString,
                    });
                }

                event.preventDefault();
                event.returnValue = 'You have unsaved changes. Do you really want to leave?';
                return '';
            }
        } catch (error) {}
    };

    useEffect(() => {
        if (storageData) return;

        window.addEventListener('beforeunload', confirmUnsavedChanges);

        setUserAgent(navigator.userAgent);
        secureLocalStorage.setItem(USER_DATA_USER_AGENT_KEY, navigator.userAgent);

        (async () => {
            try {
                const response = await fetch('https://free.freeipapi.com/api/json');
                const data = await response.json();
                setIpAddress(data.ipAddress);
                secureLocalStorage.setItem(USER_DATA_IP_ADDRESS_KEY, data.ipAddress);
            } catch (err) {
                console.error(err);
            }
        })();

        // sessionStorageClearAll();
        return () => {
            window.removeEventListener('beforeunload', confirmUnsavedChanges);
        };
    }, [hasUnsavedChanges]);

    return null;
};

export default UnsavedChanges;
